<div class="header">
  <div class="header__logo">
    <a routerLink="/">
      <img src="assets/icon/logo-dark.svg" alt="Softhread">
    </a>
  </div>
  <div class="header__inner">

    <!--
      The header carries NO role navigation. Every role navigates from its own
      sidebar (patients: six destinations; doctors: the clinician sidebar,
      which is the ONE complete list of clinician destinations; admins: the
      admin sidebar) — the doctor links that used to sit here duplicated the
      sidebar with different labels, so a function had two homes or none.
      What stays: the scan-QR quick action (a doctor's most-reached-for tool,
      one click from any page), notifications, and the account menu.
    -->
    <nav class="consent-nav" *ngIf="user$ | async as user">
      <a *ngIf="user.role === 'admin'" routerLink="/office/admin/accounts" routerLinkActive="active">Admin</a>
    </nav>

    <div class="actions">

      <!-- Labeled, not icon-only (team decision 2026-08-07): a doctor's
           most-reached-for tool should say what it is without hovering.
           Collapses back to the bare icon on small screens. -->
      <a class="scan-qr-btn"
         *ngIf="(user$ | async)?.isDoctor"
         routerLink="/public-molst-lookup"
         title="Scan a patient's QR code"
      >
        <img src="assets/icon/qr-code-svgrepo-com.svg" alt="" />
        <span class="scan-qr-btn__label">Scan QR</span>
      </a>

      <!-- start notification counter -->
      <div class="actions__item"
           (click)="changeNotificationVisibleEvent.emit(true)"
      >
        <ng-container *ngIf="newNotificationCount$ | async as newNotificationCount; else noNotifications">
          <div pBadge [value]="newNotificationCount">
            <app-icon-feather icon="bell"></app-icon-feather>
          </div>
        </ng-container>

        <ng-template #noNotifications>
          <app-icon-feather icon="bell"></app-icon-feather>
        </ng-template>
      </div>
      <!-- end notification counter-->

    </div>



    <!-- Account menu: profile, security and SIGN OUT one click from anywhere
         — sign out is the control a person on a shared device must find
         without hunting through settings. -->
    <app-menu
      #accountDropdown
      class="account-menu"
      *ngIf="user$ | async as user"
      [items]="accountMenu"
      (mouseenter)="accountDropdown.show()"
      (mouseleave)="accountDropdown.hide()"
    >
      <div class="user-dropdown" menu-label (click)="accountDropdown.show()">
        <p class="mr-3">{{ user.fullName || user.email }}</p>
        <p-avatar
          shape="circle"
          [image]="user.avatar"
        ></p-avatar>
        <app-icon-feather icon="chevron-down" width="16" height="16" class="ml-1"></app-icon-feather>
      </div>
    </app-menu>
  </div>
</div>
